import { config } from '@/config/env';
import type { LeadPayload } from '@/types/leads';

/**
 * Lo que queda del servicio de leads: armar el correo.
 *
 * Aquí vivía también `submitLead`, que hacía `POST /leads` contra el backend
 * del sitio. Ese backend se retiró el 2026-09-18 y no vuelve, así que el
 * módulo ya no habla con nadie — sólo redacta texto.
 */

/** Etiquetas del correo. Las pone la pantalla, que es la que sabe el idioma. */
export interface EtiquetasMailto {
  asuntoDemo: string;
  asuntoLoi: string;
  asuntoContacto: string;
  nombre: string;
  empresa: string;
  correo: string;
  telefono: string;
  perfil: string;
  planInteres: string;
}

/**
 * Construye el `mailto:` con lo que se escribió en el formulario.
 *
 * Las etiquetas llegan por parámetro en vez de estar escritas aquí: este módulo
 * no puede usar un hook —no es un componente— y un correo redactado en español
 * a alguien que acaba de llenar el formulario en inglés se lee como un error.
 */
export function mailtoFallback(payload: LeadPayload, etiquetas: EtiquetasMailto): string {
  const asunto =
    payload.tipo === 'demo'
      ? etiquetas.asuntoDemo
      : payload.tipo === 'loi'
        ? etiquetas.asuntoLoi
        : etiquetas.asuntoContacto;

  const cuerpo = [
    `${etiquetas.nombre}: ${payload.nombre}`,
    `${etiquetas.empresa}: ${payload.empresa}`,
    `${etiquetas.correo}: ${payload.email}`,
    payload.telefono ? `${etiquetas.telefono}: ${payload.telefono}` : null,
    `${etiquetas.perfil}: ${payload.perfil}`,
    payload.planInteres ? `${etiquetas.planInteres}: ${payload.planInteres}` : null,
    '',
    payload.mensaje,
  ]
    .filter(Boolean)
    .join('\n');

  return `mailto:${config.contactEmail}?subject=${encodeURIComponent(asunto)}&body=${encodeURIComponent(cuerpo)}`;
}
